<template>
  <v-main
    class="app-content pa-0"
    :class="{
      'quick-start-pad': store.tutorial.quickStart,
      'app-content--report-table': isHaveReportTable,
    }"
  >
    <router-view />
  </v-main>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { useStore } from '@/store';
import { isReportTableRoute } from '@/views/reports/report-route-behavior';
import { syncChatwootUser } from '@/services/utils/chatwoot';
import { getIntercomBootPayload } from '@/services/utils/support-widget';
import type { User } from '@/services/models/User';

const store = useStore();
const route = useRoute();

const isHaveReportTable = computed(() => isReportTableRoute(route.name));

const bootSupportChat = () => {
  if (!store.isAuthenticated || !store.isAuthorized) return;

  const user = store.user as User;

  if (user.featureFlags?.chatwoot?.enabled) {
    void syncChatwootUser(user);
    return;
  }

  const intercom = (
    window as {
      $intercom?: { boot: (payload: Record<string, unknown>) => void; hide: () => void };
    }
  ).$intercom;
  intercom?.boot(getIntercomBootPayload(user));
  intercom?.hide();
};

onMounted(() => {
  bootSupportChat();
});
</script>

<style lang="scss" scoped>
.app-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
}

.app-content--report-table {
  min-height: 300px;
  overflow: hidden;
}
</style>
